export default class ContactFormSubject {
    public id : string = "";
    public text : string = "";
    public showClientInfo: boolean = true;
}